/*
 * shared/accordion
 */

import SlideToggle from '../../../js/slideToggle'

const accordions = Array.from(document.querySelectorAll('[data-accordion]'))

let accordion

const addSlideToggle = el => {
    const heading = el.querySelector('[data-accordion-toggle]')
    const slideToggleHandler = e =>  new SlideToggle(heading)

    if (typeof heading === 'undefined' ) {
        return
    }

    heading.addEventListener('click', slideToggleHandler)
}

for (accordion of accordions) {
    addSlideToggle(accordion)
}
